/* eslint-disable complexity */
import { useMemo } from 'react';
import loadfonts from '~/components/Fonts';

import type { TComponentRendererProps } from '../types';
import ComponentRenderer from '../components/ComponentRenderer';

import withComponentEnhancer from './withComponentEnhancer';

loadfonts();

const withComponentRenderer = <P extends {}>({
  streamName,
  appName,
  graphqlEndpoint,
  graphqlEndpoints,
  collectorUrl,
  enableRedux,
  loader,
  baseDomain,
  enableSubscription,
  environmentOptions,
}: TComponentRendererProps) => {
  if (!(streamName && appName))
    throw new Error('Missing parameters: streamName & appName are required');

  graphqlEndpoint = graphqlEndpoint || graphqlEndpoints?.[0];

  let enhancer = withComponentEnhancer<P>({
    streamName,
    appName,
    graphqlEndpoint,
    collectorUrl,
    enableRedux,
    enableSubscription,
    environmentOptions,
  });

  return (Component: React.ComponentType<P>) => (props: P) => {
    const ComponentToRender = useMemo(() => enhancer(Component), []);
    return (
      <ComponentRenderer loader={loader} baseDomain={baseDomain} appName={appName}>
        <ComponentToRender {...props} />
      </ComponentRenderer>
    );
  };
};

export default withComponentRenderer;
